import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isExpired: false,
  code: "",
  message: "",
  businessId: null,
};

const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    setLicenseExpired: (state, action) => {
      const payload = action.payload || {};
      state.isExpired = true;
      state.code = payload.code || "LICENSE_EXPIRED";
      state.message =
        payload.message || "License expired. Please renew to continue.";
      state.businessId = payload.businessId || state.businessId || null;
    },
    clearLicenseExpired: (state) => {
      state.isExpired = false;
      state.code = "";
      state.message = "";
      state.businessId = null;
    },
  },
});

export const { setLicenseExpired, clearLicenseExpired } =
  licenseSlice.actions;
export default licenseSlice.reducer;
